import { IEnvironmentInfo, IComponentInfo, IPackageInfo, IApplicationInfo, ComponentType } from './app-context.service';
import { InventoryCounts_ModuleContextService } from './InventoryCounts.context.service';

import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class InventoryCounts_inventory_counts_in_progress_widget_ComponentContextService {
  private readonly moduleContext: InventoryCounts_ModuleContextService;

  constructor(moduleContext: InventoryCounts_ModuleContextService) {
    this.moduleContext = moduleContext;
  }

  public get app(): IApplicationInfo {
    return this.moduleContext.app;
  }

  public get env(): IEnvironmentInfo {
    return this.moduleContext.env;
  }

  public get package(): IPackageInfo {
    return this.moduleContext.package;
  }

  public get component(): IComponentInfo {
    return {
      name: 'inventory_counts_in_progress_widget',
      type: ComponentType.widget
    }
  }
}